import RushLandingPage from '../landing/rush/RushLandingPage';

const HomePage = () => <RushLandingPage />;

export default HomePage;
